import { useStaticQuery, graphql } from "gatsby";

const AllAllergensQuery = () => {
  const allAllergensData = useStaticQuery(graphql`
    query AllAllergensQuery {
      allSanityAllergen {
        nodes {
          _id
          _key
          id
          title
          icon {
            ...sanityImageFullWidth
          }
        }
      }
    }
  `);
  return allAllergensData;
};
export default AllAllergensQuery;
